// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2oBmX","rootCenter":"LoadMoreObserver_rootCenter__2pG1_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__FKiMY"};